/**
 * 問い合わせの状態選択肢
 */
export const TICKET_STATUS_OPTIONS = [
  { value: "open", label: "未対応" },
  { value: "in_progress", label: "対応中" },
  { value: "waiting_user", label: "返信待ち" },
  { value: "resolved", label: "解決済み" },
] as const;

/**
 * 問い合わせの優先度選択肢
 */
export const TICKET_PRIORITY_OPTIONS = [
  { value: "low", label: "低" },
  { value: "normal", label: "通常" },
  { value: "high", label: "高" },
  { value: "urgent", label: "緊急" },
] as const;

/**
 * 問い合わせの分類選択肢
 */
export const TICKET_CATEGORY_OPTIONS = [
  { value: "account", label: "アカウント" },
  { value: "premium", label: "ご利用プラン" },
  { value: "bug", label: "不具合" },
  { value: "general", label: "その他" },
] as const;

/**
 * 入力文字数の上限
 */
export const INPUT_LIMITS = {
  pushTitle: 100,
  pushBody: 1_000,
  ticketReply: 4_000,
} as const;

/**
 * 一覧取得件数
 */
export const PAGE_LIMITS = {
  tickets: 30,
  users: 20,
} as const;

/**
 * お知らせ配信の状態
 */
export const PUSH_CAMPAIGN_STATUSES = [
  "draft",
  "queued",
  "processing",
  "completed",
  "partial_failed",
  "failed",
] as const;

/**
 * サインイン後に最初に表示する画面
 */
export const DEFAULT_PATH = "/support" as const;
